module.exports = __webpack_public_path__ + "img/logo.a743b573.png";